module.exports = __webpack_public_path__ + "img/selected_wheelchair.ea040479.svg";